import {
  UserPendingDocsResponse,
  EnrollmentEponaResponse,
} from '@/models/pegasus-epona/enrollment-course.model';
import { eponaQuery } from '@/helpers/graphql_modules/epona';
import {
  getUserEnrollmentsQuery,
  getUserPendingDocsQuery,
} from '@/store/queries/pegasus-epona.queries';

export class UserEnrollmentsService {
  static async getUserEnrollmentsWithCourses(): Promise<EnrollmentEponaResponse> {
    const enrolledCourses = await eponaQuery(getUserEnrollmentsQuery, {});

    const {
      data: { getUserEnrollments },
    } = enrolledCourses;

    return getUserEnrollments;
  }

  static async getUserPendingDocs(): Promise<UserPendingDocsResponse[]> {
    const {
      data: {
        getUserPendingDocs: { data, identifier, message },
      },
    } = await eponaQuery(getUserPendingDocsQuery, {});

    if (!['UserPendingDocsObtained', 'NoPendingDocs'].includes(identifier))
      throw new Error(message);

    return data.userPendingDocsResponse;
  }
}
